import { querySelector, querySelectorId, querySelectorAll } from '../functions/querySelectors';
import setCookie from '../functions/setCookie';
import getCookie from '../functions/getCookie';
import alert2 from '../modules/alert';
import { initFooter, recountFooter } from '../functions/footerStickyMoving';
import { xhrLoad } from '../functions/xhrLoad';

const NEW_CONSENT_CLASS = 'c-cookie-consent';
const ALLOW_CLASS = 'js-cookie-allow';
const DENY_CLASS = 'js-cookie-deny';
const PREFERENCES_CLASS = 'js-cookie-preferences';
const CUSTOM_CLASS = 'js-cookie-custom';
const ALLOW_ALL_OBJECT = {
  'functionality_storage': 'granted',
  'ad_storage': 'granted',
  'analytics_storage': 'granted',
  'personalization_storage': 'granted',
  'ad_user_data': 'granted',
  'ad_personalization': 'granted'
};
const TECHNICAL_OBJECT = {
  'functionality_storage': 'granted',
  'ad_storage': 'denied',
  'analytics_storage': 'denied',
  'personalization_storage': 'denied',
  'ad_user_data': 'denied',
  'ad_personalization': 'denied'
};
const COOKIE_NAME = 'cookie-consent';
const COOKIE_UID_NAME = 'cookie-consent-uid';
const DOCUMENT_OPEN_CLASS = 'set-cookie-consent';
const AD_STORAGE_INPUT_ID = 'ad_storage';
const ANALYTICS_STORAGE_INPUT_ID = 'analytics_storage';
const PERSONALIZATION_STORAGE_INPUT_ID = 'personalization_storage';
const CONTENT_CLASS = 'js-cookie-alert-content';
const ALERT_MODIFS = ['cookie'];
const PARENT_ATTR = 'data-parent-id';
const CONSENT_URL = '/cookie-consent-add';

let isAlertOpen = false;

let hidePreferences = function() {
  if (isAlertOpen) {
    alert2.close();
  }
};

let showConsent = function() {
  document.documentElement.classList.add(DOCUMENT_OPEN_CLASS);
  recountFooter();
};

let hideConsent = function() {
  document.documentElement.classList.remove(DOCUMENT_OPEN_CLASS);
  recountFooter();
};

let generateUid = function() {
  return Date.now().toString(36) + Math.random().toString(36) + Math.random().toString(36).substr(2);
};

let savePreferences = function(settings) {
  let uid = getCookie(COOKIE_UID_NAME);

  if (uid === '') {
    uid = generateUid();
  }

  setCookie(COOKIE_UID_NAME, uid, 365);

  xhrLoad(`${CONSENT_URL}?uid=${uid}&preferences=${JSON.stringify(settings)}`, function(response) {
    //  nothing
  }, function() {
    //  nothing
  }, 'POST');
};

let setPreferences = function(settings) {
  if (typeof settings === 'boolean') {
    if (settings) {
      settings = ALLOW_ALL_OBJECT;
    }
    else {
      settings = TECHNICAL_OBJECT;
    }
  }

  setTimeout(() => {
    if (window.gtag && window.dataLayer) {
      window.gtag('consent', 'update', settings);
      window.dataLayer.push({
        'event': 'consentUpdate'
      });
    }

    setCookie(COOKIE_NAME, JSON.stringify(settings), 365);
    savePreferences(settings);
  }, 0);

  hideConsent();
  hidePreferences();
};

let allowClick = function(event) {
  event.preventDefault();

  setPreferences(true);
};

let denyClick = function(event) {
  event.preventDefault();

  setPreferences(false);
};

let customClick = function(event) {
  let ad = querySelectorId(AD_STORAGE_INPUT_ID);
  let analytics = querySelectorId(ANALYTICS_STORAGE_INPUT_ID);
  let personalization = querySelectorId(PERSONALIZATION_STORAGE_INPUT_ID);

  setPreferences({
    'functionality_storage': 'granted',
    'ad_storage': ad.checked ? 'granted' : 'denied',
    'analytics_storage': analytics.checked ? 'granted' : 'denied',
    'personalization_storage': personalization.checked ? 'granted' : 'denied',
    'ad_user_data': ad.checked ? 'granted' : 'denied',
    'ad_personalization': ad.checked ? 'granted' : 'denied'
  });
};

let closeAlert = function() {
  let alertContent = querySelector(`.${CONTENT_CLASS}`, this);
  let wrapperId = alertContent.getAttribute(PARENT_ATTR);
  let wrapper = querySelectorId(wrapperId);
  let data = getCookie(COOKIE_NAME);

  wrapper.appendChild(alertContent);

  if (data === '') {
    showConsent();
  }
};

let openAlert = function(event) {
  event.preventDefault();

  let wrapper = querySelector(this.getAttribute('href'));
  let cnt = querySelector(`.${CONTENT_CLASS}`, wrapper);

  cnt.setAttribute(PARENT_ATTR, wrapper.getAttribute('id'));

  alert2.open({
    nodeElement: cnt,
    modifs: [ALERT_MODIFS],
    closeCb: closeAlert,
    openCb: openCb
  });
};

let openCb = function() {
  //fill form if cookie
  let data = getCookie(COOKIE_NAME);

  if (data !== '') {
    data = JSON.parse(data);

    let ad = querySelectorId(AD_STORAGE_INPUT_ID);
    let analytics = querySelectorId(ANALYTICS_STORAGE_INPUT_ID);
    let personalization = querySelectorId(PERSONALIZATION_STORAGE_INPUT_ID);

    ad.checked = data.ad_storage === 'granted';
    analytics.checked = data.analytics_storage === 'granted';
    personalization.checked = data.personalization_storage === 'granted';
  }

  hideConsent();
  isAlertOpen = true;
};

export function cookieConsent() {
  let hasBar = querySelector(`.${NEW_CONSENT_CLASS}`);

  if (hasBar) {
    let allows = querySelectorAll(`.${ALLOW_CLASS}`);
    allows.forEach((allow) => {
      allow.addEventListener('click', allowClick);
    });

    let denies = querySelectorAll(`.${DENY_CLASS}`);
    denies.forEach((deny) => {
      deny.addEventListener('click', denyClick);
    });

    let preferences = querySelectorAll(`.${PREFERENCES_CLASS}`);
    preferences.forEach((preference) => {
      preference.addEventListener('click', openAlert);
    });

    let custom = querySelector(`.${CUSTOM_CLASS}`);
    custom.addEventListener('click', customClick);

    let data = getCookie(COOKIE_NAME);

    if (data === '') {
      showConsent();
      initFooter();
    }
  }

  let data = getCookie(COOKIE_NAME);

  if (data) {
    let parsedData = JSON.parse(data);

    if (!parsedData.ad_user_data || !parsedData.ad_personalization) {
      parsedData.ad_user_data = parsedData.ad_storage;
      parsedData.ad_personalization = parsedData.ad_storage;

      setCookie(COOKIE_NAME, JSON.stringify(parsedData), 365);

      setTimeout(() => {
        if (window.gtag && window.dataLayer) {
          window.gtag('consent', 'update', parsedData);
          window.dataLayer.push({
            'event': 'consentUpdate'
          });
        }
      });
    }
  }
}

